import { render } from "./FootbarComponent.vue?vue&type=template&id=9af3e680&scoped=true"
import script from "./FootbarComponent.vue?vue&type=script&lang=js"
export * from "./FootbarComponent.vue?vue&type=script&lang=js"

import "./FootbarComponent.vue?vue&type=style&index=0&id=9af3e680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af3e680"]])

export default __exports__